export default {"src":"/_next/static/media/logo.c99d2215.svg","height":50,"width":221,"blurWidth":0,"blurHeight":0};